module.exports = __webpack_public_path__ + "img/IMG_5530.e60ec4b8.jpg";